namespace Pages {
    export interface IPage {
        initialize(): void;
    }

    export class Page {

        constructor(protected el: Element) {
        }

        protected preventDoubleSubmit(): void {
            const FORM_SUBMITTED = 'BrdFormSubmitted';

            $('input[type=submit],button[type=submit]').click(function (ev) {
                var self = $(this);

                const form = self.closest('form');

                if (form.valid()) {
                    if (form.data(FORM_SUBMITTED)) {
                        //alert('Your form has been already submited. wait please');
                        ev.preventDefault();
                        return false;
                    }
                    else {
                        form.data(FORM_SUBMITTED, 'true');
                    }
                };
            });
        }
    }
}